import * as React from 'react';

function SvgEchIconSocialMediaInstagram2White(
  props: React.SVGProps<SVGSVGElement>,
) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" {...props}>
      <defs>
        <style>{'.cls-1{fill:#fff;}'}</style>
      </defs>
      <path
        className="cls-1"
        d="M60.17,37.39a2.25,2.25,0,1,0,2.25,2.25A2.25,2.25,0,0,0,60.17,37.39Z"
      />
      <path
        className="cls-1"
        d="M50.16,40.28a9.46,9.46,0,1,0,9.46,9.46A9.47,9.47,0,0,0,50.16,40.28Zm0,15.51a6.06,6.06,0,1,1,6.06-6A6.06,6.06,0,0,1,50.16,55.79Z"
      />
      <path
        className="cls-1"
        d="M57.67,68.94H42.33A11.55,11.55,0,0,1,30.8,57.4V42.07A11.55,11.55,0,0,1,42.33,30.53H57.67A11.55,11.55,0,0,1,69.2,42.07V57.4A11.55,11.55,0,0,1,57.67,68.94ZM42.33,34.14a7.93,7.93,0,0,0-7.92,7.93V57.4a7.93,7.93,0,0,0,7.92,7.93H57.67a7.93,7.93,0,0,0,7.92-7.93V42.07a7.93,7.93,0,0,0-7.92-7.93Z"
      />
    </svg>
  );
}
export default SvgEchIconSocialMediaInstagram2White;
